import { ActionIcon, Group, Tooltip } from "@mantine/core";
import { IconChevronDown, IconFolderShare } from "@tabler/icons-react";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import ModelActions from "./ModelActions";

const ModelActionColumn = ({ hasQuery, row, setLoading, handleRowClick }) => {
  const { modelId, folderId } = useParams();
  const model_id = parseInt(modelId) || null;
  const lang = useLanguage((s) => s.language);
  return (
    <Group wrap="nowrap" gap={4} pos={"relative"}>
      {hasQuery && row.folder?.id && (
        <Tooltip label={lang.contact_lists.folder}>
          <ActionIcon
            component={Link}
            to={`/models/folder/${row.folder.id}/model/none/type`}
            variant="subtle"
          >
            <IconFolderShare />
          </ActionIcon>
        </Tooltip>
      )}

      <ModelActions current={row} setLoading={setLoading} />

      <IconChevronDown
        size={24}
        className="bump"
        opacity={model_id === row.id ? 1 : 0.4}
        style={{
          transform: model_id === row.id ? "rotate(-90deg)" : "none",
          transition: "all ease .3s",
        }}
        onClick={() => handleRowClick({ row })}
      />

      {/* <Pinner
              row={row}
              editor={getModelTypeProps(modelType, folderId, row)?.editFunction}
              apiRef={apiRef}
              setRows={setRows}
              
            /> */}
    </Group>
  );
};

export default ModelActionColumn;
